import BackupService from '@/services/backup'
import type { Chapter } from '@/types'
import type { ChapterBackup } from '@/types/editor'

/**
 * Stores the user's local chapter text in a separate snapshot slot before applying server content.
 */
export function saveDiscardedChapterLocalCopy(
  projectId: string,
  chapterId: string,
  source: Pick<ChapterBackup, 'title' | 'jsonContent' | 'content' | 'baseUpdatedAt' | 'order'>,
): void {
  BackupService.saveDiscardedChapterSnapshot({
    projectId,
    chapterId,
    title: source.title,
    content: source.content,
    jsonContent: source.jsonContent || {},
    baseUpdatedAt: source.baseUpdatedAt,
    order: source.order,
  })
}

export function saveDiscardedChapterLocalCopyFromChapter(chapter: Chapter): void {
  saveDiscardedChapterLocalCopy(chapter.projectId, chapter._id, {
    title: chapter.title,
    jsonContent: chapter.jsonContent || {},
    content: chapter.content,
    baseUpdatedAt: chapter.updatedAt,
    order: chapter.order,
  })
}
